import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { RouteNameEnum } from '../../../enums/routeName';
import DefaultLayout from '../../../layouts/default';
import PrivateOutlet from '../../../components/PrivateOutlet';
import FeaturedBanner from '../pages';
import { PermissionEnum } from '../../../enums/permission';

const BaseRoutes: React.FC = () => (
  <Routes>
    <Route element={<DefaultLayout />}>
      <Route element={<PrivateOutlet permissionCodes={[PermissionEnum.code.productConfigViewList]} />}>
        <Route path={RouteNameEnum.featuredBanner.index} element={<FeaturedBanner />} />
      </Route>
    </Route>
  </Routes>
);

export default BaseRoutes;
